var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1261156610"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.73782 0.305625C9.14534 0.713125 9.14534 1.37383 8.73782 1.78133L2.51924 8.00002L8.73782 14.2187C9.14534 14.6263 9.14534 15.2869 8.73782 15.6944C8.33031 16.1019 7.66972 16.1019 7.2622 15.6944L0.305625 8.73783C-0.101875 8.33031 -0.101875 7.66972 0.305625 7.2622L7.2622 0.305625C7.66972 -0.101875 8.33031 -0.101875 8.73782 0.305625Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 23",
    x1: 2,
    y1: 8,
    x2: 16,
    y2: 8,
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.77c21e8fd7699bb744c6c96ea57cc808.svg";
export { ForwardRef as ReactComponent };